export default "__VITE_ASSET__CnvfuA0s__"